import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { EditorConfig } from "lexical";
import { FC, useEffect } from "react";

export const ConfigChangePlugin: FC<{ config: Record<string, unknown> }> = ({
  config,
}) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor._config = config as EditorConfig;
  }, [editor, config]);

  return null;
};
